class GuidedBundle {
  constructor(widgetSelector = '.widget-type-dynamic-bundle') {
    this.widgetSelector = widgetSelector;
    this.widget = null;
    this.items = [];
    this.actionsContainer = null;
    this.checkoutButton = null;
    this.section = null;
    this.mainProductTitleContainer = null;
    this.mainProductTitlePriceContainer = null;
    this.mainProductTitle = null;
    this.progressBar = {};
    // -1 so we can actually know if the user clicked start, first step is 0
    this.step = -1;
    this.mainProductPriceContainer = null;
    this.mainProductPriceRegular = null;
    this.mainProductPriceSale = null;
    this.mainProductPriceDiscountBadgeContainer = null;
    this.mainProductPriceDiscountBadge = null;
    this.startButton = null;
    this.prevButton = null;
    this.nextButton = null;
    this.stepsLabelElement = null;

    this.init();
  }

  async init() {
    this.widget = await this.waitForElement(this.widgetSelector);
    if (!this.widget) return;

    this.items = [...this.widget.querySelectorAll('.rebuy-product-block')];
    this.items.shift(); // Remove the first item
    if (!this.items.length) return;

    this.actionsContainer = this.widget.querySelector('.rebuy-bundle__actions');
    if (!this.actionsContainer) return;

    this.checkoutButton = this.actionsContainer.querySelector('.rebuy-bundle__actions-buttons');
    if (!this.checkoutButton) return;

    this.section = document.querySelector('#template-product');
    if (!this.section) return;

    this.mainProductTitleContainer = this.section.querySelector('.product__title__wrapper');
    this.mainProductTitlePriceContainer = this.mainProductTitleContainer.querySelector('#template-product .product__title-price__container');
    this.mainProductTitle = this.mainProductTitlePriceContainer.querySelector('#template-product .product__title');
    this.mainProductTitle.dataset.originalTitle = this.mainProductTitle.textContent;

    this.hideWidget();
    this.createStartScreen();
    this.prepareItems();
  }

  waitForElement(selector) {
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  hideWidget() {
    this.widget.style.display = 'none';
  }

  showWidget() {
    this.widget.style.display = 'block';
  }

  hideStartButton() {
    this.startButton.remove();
  }

  createStartScreen() {
    this.startButton = document.createElement('button');
    this.startButton.classList.add('btn', 'btn--guided-bundle-start-button');
    this.startButton.textContent = 'CREATE YOUR BUNDLE';
    this.startButton.addEventListener('click', () => {
      this.initLayout();
      this.nextStep();
    });

    const insertAfter = this.widget.parentElement;
    insertAfter.parentElement.insertBefore(this.startButton, insertAfter);
  }

  prepareItems() {
    this.items.forEach((item, index) => {
      item.querySelector('.rebuy-product-checkbox')?.remove();

      if (index > 0) {
        item.style.display = 'none';
      }

      item.querySelectorAll('.rebuy-color-label, .rebuy-size-label').forEach((label) => {
        label.addEventListener('click', () => {
          setTimeout(() => {
            this.updateLayout();
          }, 50);
        });
      });
    });
  }

  createAndInsertSteps() {
    const stepsContainer = document.createElement('div');
    stepsContainer.classList.add('guided-bundle__steps-container');

    this.stepsLabelElement = document.createElement('span');
    stepsContainer.appendChild(this.stepsLabelElement);

    const progressBarelement = document.createElement('div');
    progressBarelement.classList.add('guided-bundle__progress-bar');

    // We add an extra last step for the bundle review (<=)
    for (let i = 0; i <= this.items.length; i += 1) {
      const progressBarStepElement = document.createElement('button');
      progressBarStepElement.classList.add('guided-bundle__progress-bar-step');

      progressBarStepElement.onclick = (evt) => { this.goToStep(evt.target, i) };

      this.progressBar[i] = progressBarStepElement;
      progressBarelement.appendChild(progressBarStepElement);
    }
    stepsContainer.appendChild(progressBarelement);

    this.mainProductTitleContainer.insertBefore(stepsContainer, this.mainProductTitlePriceContainer);
  }

  createAndInsertPriceNodes() {
    this.mainProductPriceContainer = document.createElement('div');
    this.mainProductPriceContainer.classList.add('product__price__wrap');

    const mainProductPrice = document.createElement('div');
    mainProductPrice.classList.add('product__price');
    mainProductPrice.style.opacity = 1;
    this.mainProductPriceContainer.appendChild(mainProductPrice);

    this.mainProductPriceRegular = document.createElement('s');
    this.mainProductPriceRegular.classList.add('product__price--strike');
    mainProductPrice.appendChild(this.mainProductPriceRegular);

    this.mainProductPriceSale = document.createElement('span');
    this.mainProductPriceSale.classList.add('product__price--sale');
    mainProductPrice.appendChild(this.mainProductPriceSale);

    this.mainProductPriceDiscountBadgeContainer = document.createElement('span');
    this.mainProductPriceDiscountBadgeContainer.classList.add('product__price--discount');
    this.mainProductPriceDiscountBadgeContainer.dataset.discountPercentage = '';
    mainProductPrice.appendChild(this.mainProductPriceDiscountBadgeContainer);

    this.mainProductPriceDiscountBadge = document.createElement('span');
    this.mainProductPriceDiscountBadgeContainer.appendChild(this.mainProductPriceDiscountBadge);

    this.mainProductTitlePriceContainer.appendChild(this.mainProductPriceContainer);
  }

  createAndInsertNavButtons() {
    this.prevButton = document.createElement('button');
    this.prevButton.classList.add('btn');
    this.prevButton.style.display = 'none';
    this.prevButton.innerHTML = '<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" color="currentColor" style="display: block;"><path d="M18.5 12H6m0 0l6-6m-6 6l6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    this.prevButton.addEventListener('click', () => this.prevStep());

    this.nextButton = document.createElement('button');
    this.nextButton.classList.add('btn');
    this.nextButton.textContent = 'NEXT';
    this.nextButton.addEventListener('click', () => this.nextStep());

    const navButtonsContainer = document.createElement('div');
    navButtonsContainer.classList.add('rebuy-bundle__nav-buttons-container');
    navButtonsContainer.appendChild(this.prevButton);
    navButtonsContainer.appendChild(this.nextButton);

    this.actionsContainer.parentElement.insertBefore(navButtonsContainer, this.actionsContainer);
  }

  lastStep() {
    return this.step === this.items.length;
  }

  firstStep() {
    return this.step === 0;
  }

  hidePrevButton() {
    this.prevButton.style.display = 'none';
  }

  hideNextButton() {
    this.nextButton.style.display = 'none';
  }

  showPrevButton() {
    this.prevButton.style.display = 'block';
  }

  showNextButton() {
    this.nextButton.style.display = 'block';
  }

  updateStepLabel() {
    this.stepsLabelElement.textContent = `Step ${this.step + 1} of ${this.items.length + 1}`;

    for (let i = 0; i <= this.items.length; i++) {
      if (i <= this.step) {
        this.progressBar[i].classList.add('guided-bundle__progress-bar-step--active');
      } else {
        this.progressBar[i].classList.remove('guided-bundle__progress-bar-step--active');
      }
    }
  }

  updateMainImage() {
    const mainImageContainer = document.querySelector('.product-images__container .product__slide:first-child .lazy-image');
    if (!mainImageContainer) return;

    const mainImage = mainImageContainer.querySelector('img');
    if (!mainImage) return;

    if (!mainImage.dataset.originalSrc) {
      mainImage.dataset.originalSrc = mainImage.src;
    } else if (this.lastStep()) {
      mainImage.src = mainImage.dataset.originalSrc;
      return;
    }

    const currentImage = this.items[this.step].querySelector('.rebuy-bundle__image-item img');
    if (!currentImage) return;

    mainImageContainer.dataset.imageSrc = currentImage.dataset.highResSrc;
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = currentImage.dataset.highResSrc;
  }

  toggleItems() {
    this.items.forEach((item, index) => {
      const isLastStep = this.lastStep();
      item.style.display = index === this.step || isLastStep ? 'flex' : 'none';
      item.classList.toggle('rebuy-product-block--single', !isLastStep);

      const itemImage = item.querySelector('.rebuy-bundle__image-item');
      if (itemImage) {
        itemImage.style.display = isLastStep ? 'block' : 'none';
      }

      const itemProductInfo = item.querySelector('.rebuy-product-info');
      if (itemProductInfo) {
        itemProductInfo.style.display = isLastStep ? 'flex' : 'none';
      }
    });
  }

  toggleNav() {
    if (this.firstStep()) {
      this.hidePrevButton();
      this.showNextButton();
    } else if (this.lastStep()) {
      this.showPrevButton();
      this.hideNextButton();
    } else {
      this.showPrevButton();
      this.showNextButton();
    }
  }

  movePrevButtonToCheckout() {
    this.checkoutButton.insertBefore(this.prevButton, this.checkoutButton.firstChild);
  }

  movePrevButtonToDefault() {
    this.nextButton.parentElement.insertBefore(this.prevButton, this.nextButton);
  }

  toggleCheckoutButton() {
    if (this.lastStep()) {
      this.movePrevButtonToCheckout();
      this.checkoutButton.style.display = 'flex';
    } else {
      this.movePrevButtonToDefault();
      this.checkoutButton.style.display = 'none';
    }
  }

  updateProductInfo() {
    const currentProductTitle = this.lastStep()
      ? this.mainProductTitle.dataset.originalTitle
      : this.items[this.step].querySelector('.rebuy-product-title')?.textContent;
    this.mainProductTitle.textContent = currentProductTitle;

    const priceElement = this.lastStep() ? this.checkoutButton : this.items[this.step];
    const currentProductPriceRegular = priceElement.querySelector('.rebuy-money:not(.sale):not(.compare-at)');
    const currentProductPriceSale = priceElement.querySelector('.rebuy-money.sale');
    const currentProductPriceCompareAt = priceElement.querySelector('.rebuy-money.compare-at');

    if (currentProductPriceRegular) {
      this.mainProductPriceRegular.textContent = currentProductPriceRegular.textContent;
      this.mainProductPriceDiscountBadgeContainer.style.display = 'none';
      this.mainProductPriceDiscountBadge.textContent = '';
    } else {
      this.mainProductPriceSale.textContent = currentProductPriceSale.textContent;
      this.mainProductPriceRegular.textContent = currentProductPriceCompareAt.textContent;
      this.mainProductPriceDiscountBadgeContainer.style.display = 'block';

      let discount = 0;
      if (currentProductPriceSale) {
        discount = Math.round((1 - parseFloat(currentProductPriceSale.textContent.replace('$', '')) / parseFloat(currentProductPriceCompareAt.textContent.replace('$', ''))) * 100);
      }
      this.mainProductPriceDiscountBadge.textContent = `${discount}% OFF`;
    }
  }

  updateLayout() {
    this.toggleItems();
    this.updateStepLabel();
    this.updateMainImage();
    this.updateProductInfo();
    this.toggleNav();
    this.toggleCheckoutButton();
  }

  nextStep() {
    this.step += 1;

    if (this.step > this.items.length) {
      this.step = this.items.length;
    }

    this.updateLayout();
  }

  prevStep() {
    this.step -= 1;

    if (this.step < 0) {
      this.step = 0;
    }

    this.updateLayout();
  }

  goToStep(button, step) {
    if (!button.classList.contains('guided-bundle__progress-bar-step--active') || this.step === step) {
      return;
    }

    this.step = step;
    this.updateLayout();
  }

  initLayout() {
    this.hideStartButton();
    this.showWidget();
    this.createAndInsertSteps();
    this.createAndInsertPriceNodes();
    this.createAndInsertNavButtons();
  }
}

// Initialize the class
new GuidedBundle();